import React from 'react';
import { Typography } from '@mui/material';
import { useAppSelector } from '../../../../app/hooks';
import { WorkflowStepType } from '../../../../services/WorkflowService';
import { AutoAssignmentConfig } from './AutoAssignConfig';
import { ApprovalStepConfig } from './ApprovalConfig';

interface StepConfigurationPanelProps {
  index: number;
}

export const StepConfigurationPanel: React.FC<StepConfigurationPanelProps> = ({ index }) => {
  const step = useAppSelector((state) => state.workflow.currentWorkflow?.steps[index]);

  if (!step) return null;

  switch (step.stepType) {
    case WorkflowStepType.AutoAssignmentStep:
      return <AutoAssignmentConfig index={index} />;
    case WorkflowStepType.ApprovalStep:
      return <ApprovalStepConfig index={index} />;
    case WorkflowStepType.HstProvisioningStep:
      return (
        <Typography variant="body2" sx={{ color: '#64748b' }}>
          This step has no settings. It reads the HST user ID, role, and centers from the ticket.
        </Typography>
      );
    default:
      return null;
  }
};

export default StepConfigurationPanel;
